<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-6">
          <h3>Consulta usuarios</h3>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h4>Administradores registrados</h4>
            <span>Listado de usuarios con rol administrador.</span>
          </div>
          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </div>
            <div v-else-if="errorMsg" class="alert alert-danger" role="alert">
              {{ errorMsg }}
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Nombre</th>
                    <th>Estado</th>
                    <th>Fecha de registro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="admins.length === 0">
                    <td colspan="4" class="text-center text-muted py-4">
                      No hay administradores registrados.
                    </td>
                  </tr>
                  <tr v-for="admin in admins" :key="admin.id">
                    <td>{{ admin.email }}</td>
                    <td>{{ admin.nombre || '-' }}</td>
                    <td>
                      <span class="badge" :class="admin.activo ? 'badge-success' : 'badge-secondary'">
                        {{ admin.activo ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td>{{ formatDate(admin.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersApi } from '@/api/users';

export default {
  name: 'ConsultaUsuarios',
  data() {
    return {
      admins: [],
      loading: false,
      errorMsg: '',
      refreshIntervalId: null,
    };
  },
  mounted() {
    this.fetchAdmins();
    this.startAutoRefresh();
    window.addEventListener('focus', this.onWindowFocus);
  },
  beforeUnmount() {
    this.stopAutoRefresh();
    window.removeEventListener('focus', this.onWindowFocus);
  },
  methods: {
    async fetchAdmins() {
      this.errorMsg = '';
      try {
        if (!this.loading) this.loading = true;
        const { data } = await usersApi.getAdmins();
        this.admins = data;
      } catch (e) {
        this.errorMsg = e.response?.data?.message || 'Error al cargar administradores.';
      } finally {
        this.loading = false;
      }
    },
    startAutoRefresh() {
      if (this.refreshIntervalId) return;
      // cada 10 segundos; ajusta si quieres
      this.refreshIntervalId = setInterval(this.fetchAdmins, 10000);
    },
    stopAutoRefresh() {
      if (this.refreshIntervalId) {
        clearInterval(this.refreshIntervalId);
        this.refreshIntervalId = null;
      }
    },
    onWindowFocus() {
      // cuando vuelves a la pestaña, fuerza un refresh inmediato
      this.fetchAdmins();
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
};
</script>
